import { render, staticRenderFns } from "./AccountDetailsCommonInfoEdit.vue?vue&type=template&id=2227bfd7&scoped=true"
import script from "./AccountDetailsCommonInfoEdit.vue?vue&type=script&lang=js"
export * from "./AccountDetailsCommonInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227bfd7",
  null
  
)

export default component.exports